// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"8427b6c4","287":"2f66eec8","486":"3de22de1","651":"e4fea1ff","747":"e84d0d6b","797":"e070d22a"}[chunkId] + ".chunk.js";
};